type AppConfig = {
  surveyServiceBaseURL: string;
  propertyServiceBaseURL: string;
  userServiceBaseURL: string;
  mediaServiceBaseURL: string;
  mediaRootURL: string;
  BAMmapAPI: string;
  BAMWSO2Token: string;
  BAMWS02API: string;
  appRootURL: string;
  BAMWSO2ClientID: string;
  BAMWSO2SecretID: string;
  EnvironmentType: string;
};

export const surveyServiceBaseURL: any = process.env.NX_SURVEY_SERVICE_BASE_URL;
export const propertyServiceBaseURL: any = process.env.NX_PROPERTY_SERVICE_BASE_URL;
export const userServiceBaseURL = process.env.NX_USER_SERVICE_BASE_URL;
export const mediaServiceBaseURL = process.env.NX_MEDIA_SERVICE_BASE_URL;
export const BAMmapAPI = process.env.NX_BAM_API;
export const BAMWSO2Token = process.env.NX_WSO2_BAM_TOKEN;
export const BAMWS02API = process.env.NX_WSO2_BAM_API;
export const appRootURL = process.env.NX_APP_ROOT_URL;
export const BAMWSO2ClientID = process.env.NX_WSO2_CLIENT_ID;
export const BAMWSO2SecretID = process.env.NX_WSO2_SECRET_ID;
export const EnvironmentType = process.env.NX_ENVIRONMENT_TYPE;
export const mediaRootURL = process.env.NX_MEDIA_ROOT_URL;

export default {
  surveyServiceBaseURL,
  propertyServiceBaseURL,
  userServiceBaseURL,
  mediaServiceBaseURL,
  BAMmapAPI,
  BAMWSO2Token,
  BAMWS02API,
  appRootURL,
  BAMWSO2ClientID,
  BAMWSO2SecretID,
  EnvironmentType,
  mediaRootURL,
} as AppConfig;
